import { CheckIcon, CopyIcon } from 'lucide-react'

import {
  fieldButtonVariants,
  fieldIconVariants,
} from '~/components/component-library/Copyable/styles'
import { FieldCopyableProps } from '~/components/component-library/Copyable/types'
import { truncate } from '~/components/component-library/Copyable/utils'
import { Group } from '~/components/component-library/Group'
import { useCopyValue } from '~/hooks/useCopyValue'
import { cn } from '~/utils/tailwind-utils'

export const FieldCopyable = ({
  value,
  displayValue,
  size = 'base',
  truncateMiddle = false,
  successMessage,
  label,
  tooltip,
  footer,
  description,
}: FieldCopyableProps) => {
  const { isCopied, handleCopy } = useCopyValue()
  const truncated = truncate(value, truncateMiddle)
  const showSwap = !displayValue && truncateMiddle && truncated !== value
  const copyMessage = successMessage ?? (label ? `${label} copied` : 'Copied')

  return (
    <Group
      label={label}
      tooltip={tooltip}
      footer={footer}
      description={description}
    >
      <button
        type="button"
        onClick={(event) => {
          event.preventDefault()
          event.stopPropagation()
          handleCopy(value, copyMessage)
        }}
        aria-label={`Copy ${label ?? value}`}
        className={cn('group', fieldButtonVariants({ size }))}
      >
        {showSwap ? (
          <>
            <span className="min-w-0 truncate text-primary group-hover:hidden">
              {truncated}
            </span>
            <span className="hidden min-w-0 truncate text-primary group-hover:inline-block">
              {value}
            </span>
          </>
        ) : (
          <span className="min-w-0 truncate text-primary">
            {displayValue ?? value}
          </span>
        )}
        {isCopied ? (
          <CheckIcon className={fieldIconVariants({ size })} />
        ) : (
          <CopyIcon className={fieldIconVariants({ size })} />
        )}
      </button>
    </Group>
  )
}
